import React, { Component } from 'react';
import ROUTES from '../../shared/constants/routes';

class NoAccessComponent extends Component {
    handleBackToLogin = () => {
        this.props.history.push(ROUTES.LANDING);
    };

    render() {
        return (
            <div className="login-main">
                <a href="" onClick={(e) => e.preventDefault()} className="login-logo">
                    <img
                        src={require('../../assets/images/niagara-logo-color-2-x.png')}
                        alt="Logo"
                    />
                </a>
                <div className="login-form-container">
                    <div className="no-access-message">
                        <h3>Access Not Authorized</h3>
                        <p>Your Niagara account was verified, but you do not have access to ARMA.</p>
                        <p>Please contact Jake Atachian (<a href="mailto:jatachian@niagarawater.com">jatachian@niagarawater.com</a>) to request access.</p>
                        <div className="login-btn">
                            <button className="btn-prmry" onClick={this.handleBackToLogin}>
                                Back to Login
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NoAccessComponent;
